import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { siteInfo } from '@/mocks/siteInfo';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const navBg = isHome
    ? isScrolled
      ? 'bg-background-50/95 backdrop-blur-md'
      : 'bg-transparent'
    : 'bg-background-50/95 backdrop-blur-md';

  const textBase = isHome
    ? isScrolled
      ? 'text-foreground-900'
      : 'text-background-50'
    : 'text-foreground-900';

  const textMuted = isHome
    ? isScrolled
      ? 'text-foreground-700'
      : 'text-background-50/80'
    : 'text-foreground-700';

  const textMutedHover = isHome
    ? isScrolled
      ? 'text-foreground-700 hover:text-foreground-900'
      : 'text-background-50/80 hover:text-background-50'
    : 'text-foreground-700 hover:text-foreground-900';

  const activeColor = isHome
    ? isScrolled
      ? 'text-primary-600'
      : 'text-accent-400'
    : 'text-primary-600';

  const btnBorder = isHome
    ? isScrolled
      ? 'border-foreground-300 text-foreground-800 hover:bg-foreground-100'
      : 'border-background-50/40 text-background-50 hover:bg-background-50/15'
    : 'border-foreground-300 text-foreground-800 hover:bg-foreground-100';

  const mobileBtnColor = isHome
    ? isScrolled
      ? 'text-foreground-900'
      : 'text-background-50'
    : 'text-foreground-900';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${navBg}`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-[72px]">
          <Link to="/" className="flex items-center gap-2 group">
            <span className={`text-2xl md:text-3xl font-bold font-heading transition-colors duration-300 ${textBase}`}>
              {siteInfo.logo}
            </span>
            <span className={`hidden sm:block text-sm font-medium transition-colors duration-300 ${textMuted}`}>
              {siteInfo.tagline}
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 ${
                location.pathname === '/'
                  ? activeColor
                  : textMutedHover
              }`}
            >
              首页
            </Link>
            {categories.slice(0, 4).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 ${
                  location.pathname.includes(cat.slug)
                    ? activeColor
                    : textMutedHover
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 ${
                location.pathname === '/about'
                  ? activeColor
                  : textMutedHover
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button
              className={`whitespace-nowrap text-sm font-medium px-5 py-2 rounded-full border transition-all duration-200 ${btnBorder}`}
            >
              投稿爆料
            </button>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center ${mobileBtnColor}`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-4 flex flex-col gap-3">
            <Link to="/" className="text-sm font-medium text-foreground-800 py-2">首页</Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="text-sm font-medium text-foreground-800 py-2"
              >
                {cat.name}
              </Link>
            ))}
            <Link to="/about" className="text-sm font-medium text-foreground-800 py-2">关于我们</Link>
            <button className="whitespace-nowrap text-sm font-medium px-5 py-2 rounded-full border border-foreground-300 text-foreground-800 w-fit mt-2">
              投稿爆料
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}